import { useState, useRef } from "react";
import "./createmagasinmobile.css";
import { Link } from "react-router-dom";
import {
  Libraries,
  LoadScript,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import { Magasinenligne } from "../../Modeles/MagasinModel";

const CreateMagasinEnligneMobile: React.FC<Magasinenligne> = ({
  messageError,
  messageSucess,
  NomMagasin,
  nom,
  adress,
  email,
  password,
  Latitude,
  Longitude,
  setLatitude,
  setLongitude,
  handleSubmit,
  setNomMagasin,
  setAdress,
  setnom,
  setemail,
  setpassword,
  settele,
  setMessageError,
  setMessageSucess,
  tele,
}) => {
  const searchBoxRef = useRef<google.maps.places.SearchBox | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const libraries: Libraries = ["places"];

  const handlePlaceChanged = () => {
    const places = searchBoxRef.current?.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const formattedAddress = place.formatted_address || "";
      setAdress(formattedAddress);
      if (place.geometry && place.geometry.location) {
        setLatitude(place.geometry.location.lat());
        setLongitude(place.geometry.location.lng());
      }
    }
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "100%",
        minHeight: "120vh",
        backgroundColor: "#fcfcfcff",
        textAlign: "center",
        padding: "20px",
        fontFamily:"lato",
        paddingTop: "20px",
        margin: 0,
        overflow: "hidden",
        marginBottom:"30px",
      }}
    >
      <div className="barRetour" style={{
        marginLeft:"-80%"
      }}>
      <span className="iconRetour">
        <i onClick={handleGoBack} className="bi bi-arrow-left-short"></i>
      </span>
  </div>
      <h1
        style={{
          fontSize: "26px",
          fontWeight: "700",
          marginBottom: "50px",
          fontFamily:"lato",
          color: "black",
          textAlign: "left",
          width: "100%",
          marginTop: "0",
        }}
      >
        Créer votre magasin <br /> en ligne
      </h1>
      <form
        className="form-container"
        onSubmit={handleSubmit}
        style={{ width: "100%" }}
      >
        {" "}
        {messageError && (
          <div className="alert alert-danger">{messageError}</div>
        )}
        {messageSucess && (
          <div className="alert alert-success">{messageSucess}</div>
        )}
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          Nom Complet {" "}
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "left",
            width: "100%",
            padding: "0",
            background: "white",
            marginLeft: "0",
          }}
        >
          <input
            type="text"
            placeholder="Nom Complet"
            onChange={(e) => setnom(e.target.value)}
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "15px",
              lineHeight: "18.53px",
              fontWeight: "400",
              width: "300px",
              padding: "10px",
              margin: "0",
              border: "none",
              color: "black",
              outline: "none",
              boxSizing: "border-box",
              background: "transparent",
            }}
          />
        </div>
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          Nom Magasin{" "}
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0",
            background: "white",
          }}
        >
          <input
            type="text"
            placeholder="Nom Magasin"
            onChange={(e) => setNomMagasin(e.target.value)}
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "15px",
              lineHeight: "18.53px",
              fontWeight: "400",
              width: "100%",
              padding: "10px",
              margin: "0",
              border: "none",
              color: "black",
              outline: "none",
              boxSizing: "border-box",
              background: "transparent",
            }}
          />
        </div>
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          E-mail
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0",
            background: "white",
          }}
        >
          <input
            type="email"
            placeholder="Adresse E-mail"
            onChange={(e) => setemail(e.target.value)}
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "15px",
              lineHeight: "18.53px",
              fontWeight: "400",
              width: "100%",
              padding: "10px",
              margin: "0",
              border: "none",
              color: "black",
              outline: "none",
              boxSizing: "border-box",
              background: "transparent",
            }}
          />
        </div>
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          Numéro de téléphone{" "}
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0",
            background: "white",
          }}
        >
          <input
            type="text"
            placeholder="Numéro de téléphone"
            onChange={(e) => settele(e.target.value)}
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "15px",
              lineHeight: "18.53px",
              fontWeight: "400",
              width: "100%",
              padding: "10px",
              margin: "0",
              border: "none",
              color: "black",
              outline: "none",
              boxSizing: "border-box",
              background: "transparent",
            }}
          />
        </div>
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          Localisation
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0",
            background: "white",
          }}
        >
          <LoadScript
            googleMapsApiKey="AIzaSyBmLZdgzjt2mfMeAb-iZTkUeNYWqPU1FoE"
            libraries={libraries}
          >
            <StandaloneSearchBox
              onLoad={(ref) => (searchBoxRef.current = ref)}
              onPlacesChanged={handlePlaceChanged}
            >
              <input
                type="text"
                placeholder="Entrez votre adresse"
                ref={inputRef}
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: "15px",
                  lineHeight: "18.53px",
                  fontWeight: "400",
                  width: "300px",
                  padding: "10px",
                  margin: "0",
                  border: "none",
                  color: "black",
                  outline: "none",
                  boxSizing: "border-box",
                  background: "transparent",
                }}
              />
            </StandaloneSearchBox>
          </LoadScript>
        </div>
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          Mot de passe{" "}
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0",
            background: "white",
          }}
        >
          <input
            type="password"
            placeholder="Mot de passe"
            onChange={(e) => setpassword(e.target.value)}
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "15px",
              lineHeight: "18.53px",
              fontWeight: "400",
              width: "300px",
              padding: "10px",
              margin: "0",
              border: "none",
              color: "black",
              outline: "none",
              boxSizing: "border-box",
              background: "transparent",
            }}
          />
        </div>
        <label
          style={{
            display: "block",
            textAlign: "left",
            marginBottom: "5px",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
          }}
        >
          Confirmation mot de passe{" "}
        </label>
        <div
          style={{
            position: "relative",
            marginBottom: "15px",
            border: "1px solid #000000",
            boxSizing: "border-box",
            borderRadius: "0px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "0",
            background: "white",
          }}
        >
          <input
            type="password"
            placeholder="Confirmation mot de passe"
            onChange={(e) => setpassword(e.target.value)}
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "15px",
              lineHeight: "18.53px",
              fontWeight: "400",
              width: "300px",
              padding: "10px",
              margin: "0",
              border: "none",
              color: "black",
              outline: "none",
              boxSizing: "border-box",
              background: "transparent",
            }}
          />
        </div>


        <p
          style={{
            fontSize: "13px",
            marginTop: "10px",
            fontFamily:"lato",
            color: "black",
            fontWeight: "500",
            textAlign: "left",
            marginBottom: "15px",
          }}
        >
          En vous inscrivant, vous acceptez nos{" "}
          <Link
            to=""
            style={{
              fontFamily:"lato",
              fontSize: "13px",
              color: "black",
              fontWeight: "600",
              textDecoration: "underline",
            }}
          >
            Conditions
          </Link>
          , <br />
          notre{""}
          <Link
            to=""
            style={{
              fontSize: "13px",
              color: "black",
              fontWeight: "600",
              textDecoration: "underline",
            }}
          >
            Politique de confidentialité
          </Link>
          .
        </p>
        <button
          type="submit"
          className="btn-create"
          style={{
            width: "100%",
            padding: "8px",
            marginTop: "-5px",
            backgroundColor: "#FFC300",
            border: "none",
            color: "black",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            borderRadius: "5px",
            marginBottom: "35px",
            marginLeft: "0",
            boxSizing: "border-box",
            display: "block",
          }}
        >
          Créer
        </button>
        <p
          style={{
            fontSize: "14px",
            marginTop: "10px",
            fontFamily: "Public Sans, sans-serif",
            color: "#808080",
            fontWeight: "400",
          }}
        >
          Vous avez déjà un compte?{" "}
          <Link
            to="/seconnecter"
            style={{
              fontSize: "14px",
              marginTop: "10px",
              fontFamily: "Public Sans, sans-serif",
              color: "#000000",
              fontWeight: "400",
              textDecoration: "underline",
            }}
          >
            Connectez-vous{""}
          </Link>
        </p>

      </form>
    </div>
  );
};

export default CreateMagasinEnligneMobile;
